import Item from '../../canvas-timeline/canvas_timeline_item';
import {
	ITEM_TYPE,
	getTextColor,
	drawRectangle,
	getTrimmedText,
	TIMELINE_BAR_BORDER_RADIUS,
	TIMELINE_BAR_PADDING_X,
	GROUP_SECTION_TEXT_GREY_DARK, TIMELINE_GREY_TASK_BAR_COLOR,
} from '../../canvas-timeline/canvas_timeline_util';
import Util from '../../../../forecast-app/shared/util/util';
import Color from 'color';
import {hasFeatureFlag} from "../../../../forecast-app/shared/util/FeatureUtil";

class PhaseItem extends Item {
	constructor(data) {
		super(ITEM_TYPE.PROJECT_SCHEDULING_PHASE, data);
	}

	draw(canvasContext, x, y, width, canvasWidth) {
		if (hasFeatureFlag("timeline_group_section_restyling")) {
			const {data, height} = this;
			const {color, faded, phaseName} = data;
			const modifiedProjectColor = color.toLowerCase() === '#e6e6ed' ? TIMELINE_GREY_TASK_BAR_COLOR : color;

			const completion = data.completion < 0 ? 0 : data.completion;
			const textColor = GROUP_SECTION_TEXT_GREY_DARK;
			const phaseColor = Color(modifiedProjectColor);
			const minimumTrim = 45;
			const middlePadding = 20;
			const phaseNameFont = '600 11px ' + Util.getFontFamily();
			const phaseCompletionFont = '600 11px ' + Util.getFontFamily();

			// Visible item stats
			const visibleRightX = x + width > canvasWidth ? canvasWidth : x + width;
			const visibleLeftX = x > 0 ? x : 0;
			const visibleItemWidth = visibleRightX - visibleLeftX;

			// Phase Name
			canvasContext.font = phaseNameFont;
			const phaseNameTextWidth = canvasContext.measureText(phaseName).width;

			// Completion
			const completionString = `${completion}%`;
			const completionStringWidth = canvasContext.measureText(completionString).width;

			const textTrim = visibleItemWidth - TIMELINE_BAR_PADDING_X * 2;
			const rightSize = completionStringWidth + TIMELINE_BAR_PADDING_X * 2;

			const showLeft = textTrim > minimumTrim;
			const showRight = visibleItemWidth - (rightSize + middlePadding) > phaseNameTextWidth;

			//Draw background
			const options = {
				backgroundColor: phaseColor,
				backgroundOpacity: faded ? 0.2 : completion === 100 ? 1 : 0.7,
				borderRadius: TIMELINE_BAR_BORDER_RADIUS,
			};
			drawRectangle(canvasContext, x, y, width, height, options);

			//Draw progress bar if needed
			if (completion !== 0 && completion !== 100) {
				//The last path drawn is the shape of item, use that as a clipping path to draw progress
				canvasContext.save();
				canvasContext.clip();

				//draw completion rectangle
				const completionRecOptions = {
					backgroundColor: phaseColor,
					backgroundOpacity: faded ? 0.2 : 1,
				};
				const completionWidth = (width * completion) / 100;
				drawRectangle(canvasContext, x, y, completionWidth, height, completionRecOptions);
				canvasContext.restore();
			}

			if (!showLeft && !showRight) {
				return;
			}

			if (showLeft) {
				//Phase Name
				canvasContext.fillStyle = textColor;
				canvasContext.font = phaseNameFont;
				canvasContext.fillText(
					getTrimmedText(canvasContext, phaseName, textTrim),
					visibleLeftX + TIMELINE_BAR_PADDING_X,
					y + 21,
				);
			}

			if (showRight) {
				// Completion
				canvasContext.fillStyle = textColor;
				canvasContext.font = phaseCompletionFont;
				canvasContext.fillText(
					completionString,
					visibleRightX - TIMELINE_BAR_PADDING_X - completionStringWidth,
					y + 21,
				);
			}
		} else {
			const {data, height} = this;
			const {color, faded, phaseName} = data;

			const completion = data.completion < 0 ? 0 : data.completion;
			const textColor = getTextColor(color);
			const phaseColor = Color(color);
			const textMargin = 16;
			const minimumTrim = 45;
			const middlePadding = 20;

			// Visible item stats
			const visibleRightX = x + width > canvasWidth ? canvasWidth : x + width;
			const visibleLeftX = x > 0 ? x : 0;
			const visibleItemWidth = visibleRightX - visibleLeftX;

			// Phase Name
			canvasContext.font = '12px ' + Util.getFontFamily();
			const phaseNameTextWidth = canvasContext.measureText(phaseName).width;

			// Completion
			const completionString = `${completion}%`;
			canvasContext.font = '500 12px ' + Util.getFontFamily();
			const completionStringWidth = canvasContext.measureText(completionString).width;

			const textTrim = visibleItemWidth - textMargin * 2;
			const rightSize = completionStringWidth + textMargin * 2;

			const showLeft = textTrim > minimumTrim;
			const showRight = visibleItemWidth - (rightSize + middlePadding) > phaseNameTextWidth;

			//Draw background
			const options = {
				backgroundColor: phaseColor,
				backgroundOpacity: faded ? 0.2 : completion === 100 ? 1 : 0.7,
				isCornerTopRightCutOff: true,
				isCornerTopLeftCutOff: true,
			};
			drawRectangle(canvasContext, x, y, width, height, options);
			//Draw progress bar if needed
			if (completion !== 0 && completion !== 100) {
				//The last path drawn is the shape of item, use that as a clipping path to draw progress
				canvasContext.save();
				canvasContext.clip();

				//draw completion rectangle
				const completionRecOptions = {
					backgroundColor: phaseColor,
					backgroundOpacity: faded ? 0.2 : 1,
				};
				const completionWidth = (width * completion) / 100;
				drawRectangle(canvasContext, x, y, completionWidth, height, completionRecOptions);
				canvasContext.restore();
			}

			if (!showLeft && !showRight) {
				return;
			}

			if (showLeft) {
				//Phase Name
				canvasContext.fillStyle = textColor;
				canvasContext.font = '12px ' + Util.getFontFamily();
				canvasContext.fillText(getTrimmedText(canvasContext, phaseName, textTrim), textMargin + visibleLeftX, y + 20);
			}

			if (showRight) {
				// Completion
				canvasContext.fillStyle = textColor;
				canvasContext.font = '500 12px ' + Util.getFontFamily();
				canvasContext.fillText(completionString, visibleRightX - textMargin - completionStringWidth, y + 20);
			}
		}
	}
}
export default PhaseItem;
